import React, { useEffect, useState } from 'react'
import { post, Token, url } from '../../../../../Script/Session';
import { useNavigate, useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from '@mui/joy';
import FragenBeantworteradvanced from './panels/FragenBeantworteradvanced';
import EmpfehlungEditor from '../components/EmpfehlungEditor';
import AdvancedEmpfehlungeditor from './panels/AdvancedEmpfehlungeditor';
import PflichtdateienLoader from './panels/PflichtdateienLoader';

function TarifstandCreator() {

  const [data, setdata] = useState();
  const { id, hold } = useParams();
  const [pfdateien, setpfdateien] = useState({});
  const navigate = useNavigate();
  const [fragen, setfragen] = React.useState(new Map());
  const [bewertung, setbewertung] = React.useState(new Map());
  const [file, setfile] = React.useState(new Map());
  const [filedata, setfiledata] = React.useState(new Map());
  const [empfehlung, setempfehlung] = useState("");
  const [übernahme, setübernahme] = useState(new Map());
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    const fetchVereinData = () => {
      const body = {
        token: Token.get(),
        action: "get_tarif",
        targettarif: Number(id),
      };

      try {
        let response = post(body, "/tarife/general");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }

        setdata(JSON.parse(response));
        workprevios(JSON.parse(response));
        console.log("Debug!! " + response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };



    setTimeout(() => {
      fetchVereinData();
    }, 15);




  }, []);
  useEffect(() => {
    const key = `create-tarif-data-${id}`;
    const storedData = localStorage.getItem(key);
    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);
        if (parsed.dateien) {
          setpfdateien(parsed.dateien);
        }
        localStorage.removeItem(key);
      } catch (e) {
        console.error("Fehler beim Parsen der Daten:", e);
      }
    }
  }, [id]);

  const workprevios = (data) => {
    let s = new Map(fragen);
    let a = new Map(bewertung);
    if (empfehlung == "") {
      setempfehlung(data.lasttarif.empfehlung);
    }
    data.fragen.map((item, index) => {
      const keys = Object.keys(item).filter(k => k !== "order");
      const name = keys[0] || "Unbenannt";
      {
        Array.isArray(item[name]) &&
          item[name]
            .map((frage, idx) => {
              if (data.lasttarif.questions.find((a) => a.question === frage.name)?.antwort) {
                if (!fragen.has(frage.name)) {

                  let n = data.lasttarif.questions.find((a) => a.question === frage.name)?.antwort;
                  s.set(frage.name, n ?? "");


                }

                if (!bewertung.has(frage.name)) {

                  let n = frage.bewertung.find((e) => data.lasttarif.bewertung.find((i) => i.question === frage.name)?.bewertung == e.id);
                  a.set(frage.name, n ?? null);
                  console.log(n);
                }
              }

            })
      }
    });

    setfragen(s);
    setbewertung(a);
    let h = value;
    setValue(1);
    setTimeout(() => {
      setValue(0);
    }, 15);
  }
  function send() {
    const formData = new FormData();
    let body = {};
    body.token = Token.get();
    body.targettarif = data.id;
    body.empfehlung = empfehlung;
    body.fragen = JSON.stringify(Object.fromEntries(fragen));
    body.bewertung = JSON.stringify(
      Array.from(bewertung.entries()).map(([key, value]) => [
        key,
        value && typeof value === "object" && "id" in value ? value.id : value ?? null
      ])
    );
    body.filedata = JSON.stringify(Object.fromEntries(filedata));
    body.übernahme = JSON.stringify(Object.fromEntries(übernahme));
    console.log(JSON.stringify(body));
    formData.append("json", JSON.stringify(body));
    file.values().forEach(file => {
      formData.append("file", file); // gleicher Schlüssel "file"
    });

    fetch(url + "/api/tarife/create_tarif_stand", {
      method: "POST",
      body: formData,
    })
      .then(res => res.text()) // EINMAL aufrufen
      .then(text => {
        console.log(text);
        if (text === "OK") {
          window.open('', '_self'); // öffnet eine leere Seite im selben Tab
          window.close();
        }
      })
      .catch(console.error);
  }
  const handleChange = (event, newValue) => {
    if (newValue == 3) {
      send();
      return;
    }
    setValue(newValue);
  };

  if (!data) {
    return (<></>);
  }
  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider', width: "100%", minHeight: "100vh" }}
      >
        <TabList>
          <Tab>Leistungsübersicht</Tab>
          <Tab>Pflichtdateien</Tab>
          <Tab>Empfehlung</Tab>
          <Tab sx={{ color: "red" }}>Speichern</Tab>

        </TabList>

        <TabPanel value={0}><FragenBeantworteradvanced data={data} fragen={fragen} setfragen={setfragen} bewertung={bewertung} setbewertung={setbewertung} /></TabPanel>
        <TabPanel value={1}><PflichtdateienLoader dateiendata={filedata} setdateiendata={setfiledata} files={file} setfile={setfile} übernehmen={hold} pflichtdateien={pfdateien} lasttarif={data}
          übernahme={übernahme} setübernahme={setübernahme} /></TabPanel>
        <TabPanel value={2}><AdvancedEmpfehlungeditor data={data} empfehlung={empfehlung} setempfehlung={setempfehlung} /></TabPanel>
      </Tabs>

    </>
  )
}

export default TarifstandCreator
